import { withCommas } from "../../common/Utils";
import AbsComponent from "../AbsComponent";

export default class Abilities extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
    }

    compare(_d1, _d2){
        if (_d1>_d2) {
            return `<span class="icon morethan">▲</span>`;
        }
        if (_d1<_d2) {
            return `<span class="icon lessthan">▼</span>`;
        }
        if (_d1===_d2) {
            return `<span class="icon equal">-</span>`;
        }
    }

    setting(_d, _d2, _clazz, _parent, _compareMode = false){
        $(_parent).toggle(this.store.getState().isAllowed);
        if (!this.store.getState().isAllowed) {
            return;
        }
        
        if (!_d.data.total_ability) return false;
        
        _d = _d.data;
        let isCompare = !!_d2;

        let templ = $(`
<dl class="stat-define">
    <dt class="stat-title stat-important">
        ${isCompare? this.compare(_d.total_ability.int_attack_power_value, _d2.total_ability.int_attack_power_value): ``}
        <span class="title">${this.l10n.attackPower}</span>
        <span class="stat-point">${_d.total_ability.int_attack_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_attack_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_attack_power_value}</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.pc_attack_power_value, _d2.total_ability.pc_attack_power_value): ``}
        <span class="title">${this.l10n.pcAttackPower}</span>
        <span class="stat-point">${_d.total_ability.pc_attack_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.pc_attack_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.pc_attack_power_value}</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.boss_attack_power_value, _d2.total_ability.boss_attack_power_value): ``}
        <span class="title">${this.l10n.bossAttackPower}</span>
        <span class="stat-point">${_d.total_ability.boss_attack_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.boss_attack_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.boss_attack_power_value}</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_attack_pierce_value, _d2.total_ability.int_attack_pierce_value): ``}
        <span class="title">${this.l10n.pierce}</span>
        <span class="stat-point">${_d.total_ability.int_attack_pierce_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_attack_pierce_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_attack_pierce_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.defendPierce}</span>
                <span class="stat-point">${_d.total_ability.attack_defend_pierce_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.parryPierce}</span>
                <span class="stat-point">${_d.total_ability.attack_parry_pierce_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_attack_hit_value, _d2.total_ability.int_attack_hit_value): ``}
        <span class="title">${this.l10n.attackHit}</span>
        <span class="stat-point">${_d.total_ability.int_attack_hit_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_attack_hit_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_attack_hit_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackHitRate}</span>
                <span class="stat-point">${_d.total_ability.attack_hit_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_attack_concentrate_value, _d2.total_ability.int_attack_concentrate_value): ``}
        <span class="title">${this.l10n.attackConcentrate}</span>
        <span class="stat-point">${_d.total_ability.int_attack_concentrate_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_attack_concentrate_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_attack_concentrate_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackPerfectParryDamageRate}</span>
                <span class="stat-point">${_d.total_ability.attack_perfect_parry_damage_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackCounterDamageRate}</span>
                <span class="stat-point">${_d.total_ability.attack_counter_damage_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_attack_critical_value, _d2.total_ability.int_attack_critical_value): ``}
        <span class="title">${this.l10n.attackCritical}</span>
        <span class="stat-point">${_d.total_ability.int_attack_critical_value>9999? withCommas(_d.total_ability.int_attack_critical_value): _d.total_ability.int_attack_critical_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_attack_critical_value>9999? withCommas(_d.base_ability.int_attack_critical_value): _d.base_ability.int_attack_critical_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_attack_critical_value>9999? withCommas(_d.equipped_ability.int_attack_critical_value): _d.equipped_ability.int_attack_critical_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackCriticalRate}</span>
                <span class="stat-point">${_d.total_ability.attack_critical_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.attack_critical_damage_value, _d2.total_ability.attack_critical_damage_value): ``}
        <span class="title">${this.l10n.attackCriticalDamage}</span>
        <span class="stat-point">${_d.total_ability.attack_critical_damage_value>9999? withCommas(_d.total_ability.attack_critical_damage_value): _d.total_ability.attack_critical_damage_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.attack_critical_damage_value>9999? withCommas(_d.base_ability.attack_critical_damage_value): _d.base_ability.attack_critical_damage_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.attack_critical_damage_value>9999? withCommas(_d.equipped_ability.attack_critical_damage_value): _d.equipped_ability.attack_critical_damage_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.attack_critical_damage_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title empty">
        ${isCompare? this.compare(_d.total_ability.int_attack_stiff_duration_level, _d2.total_ability.int_attack_stiff_duration_level): ``}
        <span class="title">${this.l10n.attackStiffDuration}</span>
        <span class="stat-point">${_d.total_ability.int_attack_stiff_duration_level}${this.l10n.step}</span>
    </dt>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_attack_damage_modify_diff, _d2.total_ability.int_attack_damage_modify_diff): ``}
        <span class="title">${this.l10n.attackDamageModify}</span>
        <span class="stat-point">${_d.total_ability.int_attack_damage_modify_diff}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.attackCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.attack_damage_modify_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_hate_power_value, _d2.total_ability.int_hate_power_value): ``}
        <span class="title">${this.l10n.hatePowerest}</span>
        <span class="stat-point">${_d.total_ability.hate_power_rate}%</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_hate_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_hate_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.hatePowerRate}</span>
                <span class="stat-point">${_d.total_ability.hate_power_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.abnormal_attack_power_value, _d2.total_ability.abnormal_attack_power_value): ``}
        <span class="title">${this.l10n.abnormalAttackPower}</span>
        <span class="stat-point">${_d.total_ability.abnormal_attack_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.abnormal_attack_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.abnormal_attack_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.abnormal_attack_power_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.attack_attribute_value, _d2.total_ability.attack_attribute_value): ``}
        <span class="title">${this.l10n.attackAttribute}</span>
        <span class="stat-point">${_d.total_ability.attack_attribute_value>9999? withCommas(_d.total_ability.attack_attribute_value): _d.total_ability.attack_attribute_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.attack_attribute_value>9999? withCommas(_d.base_ability.attack_attribute_value): _d.base_ability.attack_attribute_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.attack_attribute_value>9999? withCommas(_d.equipped_ability.attack_attribute_value): _d.equipped_ability.attack_attribute_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.attackAttributeRate}</span>
                <span class="stat-point">${_d.total_ability.attack_attribute_rate}%</span>
            </li>
        </ul>
    </dd>
</dl>
<dl class="stat-define">
    <!-- 강체는 투사일 경우에만 노출. 강체/생명력은 배경 강조 stat-important 추가-->
    ${_clazz==='warrior' || _compareMode?`
    <dt class="stat-title stat-important">
        ${isCompare? this.compare(_d.total_ability.guard_gauge, _d2.total_ability.guard_gauge): ``}
        <span class="title">${this.l10n.guardGauge}</span>
        <span class="stat-point">${_d.total_ability.guard_gauge}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.guard_gauge}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.guard_gauge}</span>
            </li>
        </ul>
    </dd>
    `:``}

    <dt class="stat-title stat-important">
        ${isCompare? this.compare(_d.total_ability.int_max_hp, _d2.total_ability.int_max_hp): ``}
        <span class="title">${this.l10n.maxHp}</span>
        <span class="stat-point">${_d.total_ability.int_max_hp>9999? withCommas(_d.total_ability.int_max_hp): _d.total_ability.int_max_hp}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_max_hp>9999? withCommas(_d.base_ability.int_max_hp): _d.base_ability.int_max_hp}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_max_hp>9999? withCommas(_d.equipped_ability.int_max_hp): _d.equipped_ability.int_max_hp}</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_defend_power_value, _d2.total_ability.int_defend_power_value): ``}
        <span class="title">${this.l10n.defendPower}</span>
        <span class="stat-point">${_d.total_ability.int_defend_power_value>9999? withCommas(_d.total_ability.int_defend_power_value): _d.total_ability.int_defend_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_defend_power_value>9999? withCommas(_d.base_ability.int_defend_power_value): _d.base_ability.int_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_defend_power_value>9999? withCommas(_d.equipped_ability.int_defend_power_value): _d.equipped_ability.int_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.defendPowerRate}</span>
                <span class="stat-point">${_d.total_ability.defend_physical_damage_reduce_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendPower}</span>
                <span class="stat-point">${_d.total_ability.int_aoe_defend_power_value>9999? withCommas(_d.total_ability.int_aoe_defend_power_value): _d.total_ability.int_aoe_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendDamageReduceRate}</span>
                <span class="stat-point">${_d.total_ability.aoe_defend_damage_reduce_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.pc_defend_power_value, _d2.total_ability.pc_defend_power_value): ``}
        <span class="title">${this.l10n.pcDefendPower}</span>
        <span class="stat-point">${_d.total_ability.pc_defend_power_value>9999? withCommas(_d.total_ability.pc_defend_power_value): _d.total_ability.pc_defend_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.pc_defend_power_value>9999? withCommas(_d.base_ability.pc_defend_power_value): _d.base_ability.pc_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.pc_defend_power_value>9999? withCommas(_d.equipped_ability.pc_defend_power_value): _d.equipped_ability.pc_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.pcDefendPowerRate}</span>
                <span class="stat-point">${_d.total_ability.pc_defend_power_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendPower}</span>
                <span class="stat-point">${_d.total_ability.aoe_defend_power_value>9999? withCommas(_d.total_ability.aoe_defend_power_value): _d.total_ability.aoe_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendDamageReduceRate}</span>
                <span class="stat-point">${_d.total_ability.aoe_defend_damage_reduce_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.boss_defend_power_value, _d2.total_ability.boss_defend_power_value): ``}
        <span class="title">${this.l10n.bossDefendPower}</span>
        <span class="stat-point" id="total-boss_defend_power_value">${_d.total_ability.boss_defend_power_value>9999? withCommas(_d.total_ability.boss_defend_power_value): _d.total_ability.boss_defend_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.boss_defend_power_value>9999? withCommas(_d.base_ability.boss_defend_power_value): _d.base_ability.boss_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.boss_defend_power_value>9999? withCommas(_d.equipped_ability.boss_defend_power_value): _d.equipped_ability.boss_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.bossDefendPowerRate}</span>
                <span class="stat-point">${_d.total_ability.boss_defend_power_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendPower}</span>
                <span class="stat-point">${_d.total_ability.aoe_defend_power_value>9999? withCommas(_d.total_ability.aoe_defend_power_value): _d.total_ability.aoe_defend_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.aoeDefendDamageReduceRate}</span>
                <span class="stat-point">${_d.total_ability.aoe_defend_damage_reduce_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_defend_dodge_value, _d2.total_ability.int_defend_dodge_value): ``}
        <span class="title">${this.l10n.defendDodge}</span>
        <span class="stat-point">${_d.total_ability.int_defend_dodge_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_defend_dodge_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_defend_dodge_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.probability}</span>
                <span class="stat-point">${_d.total_ability.defend_dodge_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.counterDamageReduceRate}</span>
                <span class="stat-point">${_d.total_ability.counter_damage_reduce_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_defend_parry_value, _d2.total_ability.int_defend_parry_value): ``}
        <span class="title">${this.l10n.defendParry}</span>
        <span class="stat-point">${_d.total_ability.int_defend_parry_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.basic}</span>
                <span class="stat-point">${_d.base_ability.int_defend_parry_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.equip}</span>
                <span class="stat-point">${_d.equipped_ability.int_defend_parry_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.defendCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.defend_parry_reduce_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.perfectParryDamageReduceRate}</span>
                <span class="stat-point">${_d.total_ability.perfect_parry_damage_reduce_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.defendParryRate}</span>
                <span class="stat-point">${_d.total_ability.defend_parry_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_defend_critical_value, _d2.total_ability.int_defend_critical_value): ``}
        <span class="title">${this.l10n.defendCritical}</span>
        <span class="stat-point">${_d.total_ability.int_defend_critical_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.defendCriticalRate}</span>
                <span class="stat-point">${_d.total_ability.defend_critical_rate}%</span>
            </li>
            <li>
                <span class="title">${this.l10n.defendCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.defend_critical_damage_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title empty">
        ${isCompare? this.compare(_d.total_ability.defend_stiff_duration_level, _d2.total_ability.defend_stiff_duration_level): ``}
        <span class="title">${this.l10n.defendStiffDurationLevel}</span>
        <span class="stat-point">${_d.total_ability.defend_stiff_duration_level}${this.l10n.step}</span>
    </dt>

    <dt class="stat-title">
        <span class="title">${this.l10n.defendCriticalDamageRate}</span>
        <span class="stat-point">${_d.total_ability.int_defend_damage_modify_diff}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.defendCriticalDamageRate}</span>
                <span class="stat-point">${_d.total_ability.defend_damage_modify_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.int_hp_regen, _d2.total_ability.int_hp_regen): ``}
        <span class="title">${this.l10n.hpRegen}</span>
        <span class="stat-point">${_d.total_ability.int_hp_regen}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.stateOfPeace}</span>
                <span class="stat-point">${_d.total_ability.int_hp_regen}</span>
            </li>
            <li>
                <span class="title">${this.l10n.hpRegenCombat}</span>
                <span class="stat-point">${_d.total_ability.int_hp_regen_combat}</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.heal_power_rate, _d2.total_ability.heal_power_rate): ``}
        <span class="title">${this.l10n.healPowerRate}</span>
        <span class="stat-point">${_d.total_ability.heal_power_rate}%</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.healPower}</span>
                <span class="stat-point">${_d.total_ability.heal_power_value}</span>
            </li>
            <li>
                <span class="title">${this.l10n.healPowerDiff}</span>
                <span class="stat-point">${_d.total_ability.heal_power_diff}</span>
            </li>
            <li>
                <span class="title">${this.l10n.healPowerRate2}</span>
                <span class="stat-point">${_d.total_ability.heal_power_rate}%</span>
            </li>
        </ul>
    </dd>

    <dt class="stat-title">
        ${isCompare? this.compare(_d.total_ability.abnormal_defend_power_value, _d2.total_ability.abnormal_defend_power_value): ``}
        <span class="title">${this.l10n.abnormalDefendPower}</span>
        <span class="stat-point">${_d.total_ability.abnormal_defend_power_value}</span>
    </dt>
    <dd class="stat-description">
        <ul class="ratio">
            <li>
                <span class="title">${this.l10n.abnormalDefendPowerRate}</span>
                <span class="stat-point">${_d.total_ability.abnormal_defend_power_rate}%</span>
            </li>
        </ul>
    </dd>

</dl>`);

        $(_parent).empty().append(templ);

        templ.find('.stat-title').on('click', e => {
            $(e.currentTarget).toggleClass('is-active');
            return false;
        });
    }


} // end of class